<template>
  <div class="analysis-filter-page col-block default-shadow" :style="{ height: minHeight }">
    <div v-if="disabled" class="mask"></div>
    <div class="title-container center-block">
      <div class="title">{{ title }}</div>
    </div>
    <div class="filter-container">
      <customFilter
        :init="filters.init"
        :filters="filters.options"
        @change="conditions => filtersOnChange(conditions)"
        @pressEnter="() => updateFilter()"
      ></customFilter>
      <div class="button">
        <button type="button" name="button" class="main-button" @click="e => updateFilter()">
          <span>搜尋</span>
        </button>
      </div>
    </div>
    <hr>
    <div class="weighting-container" :style="{ flex: 1 }">
      <weightingFilter
        :init="weightings.init"
        :filters="weightings.options"
        :disabled="weightings.disabled"
        @change="conditions => weightingsOnChange(conditions)"
      ></weightingFilter>
    </div>
  </div>
</template>

<script>
import customFilter from '../tool/customFilter'
import weightingFilter from '../tool/weightingFilter'

export default {
  components: {
    customFilter,
    weightingFilter
  },
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    },
    weightings: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      conditions: {
        filters: {},
        weightings: {}
      }
    }
  },
  methods: {
    filtersOnChange (conditions) {
      // const init = !Object.values(this.conditions.filters).every(x => x)
      const init = false
      this.conditions.filters = conditions
      if (init) {
        this.updateFilter()
      }
    },
    updateFilter () {
      this.$emit('changeFilters', JSON.parse(JSON.stringify(this.conditions.filters)))
    },
    weightingsOnChange (conditions) {
      this.conditions.weightings = conditions
      this.$emit('changeWeightings', JSON.parse(JSON.stringify(this.conditions.weightings)))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analysis/filter.vue